export var ENTITY = "cards";
export var REDUCER_KEY = "CARDS";
export var BASE_PATH_ENTITY = "cards";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    legacyGetDetail: true,
};
